export const UNDER_CONSTRUCTION_PAGES = {
};

export const isPageUnderConstruction = (path) => {
  return UNDER_CONSTRUCTION_PAGES[path] || false;
};
